module.exports = __webpack_public_path__ + "static/media/arrow.8a67f61c.svg";